angular.module('impactx.approval').directive('ixEmbeddedApprovalStatus', function($window) {
    return {
        scope: {
            steps: '=',
            trns: '=',
            status: '=',
            redirectFunction: '&?',
            viewToggle: '=',
            viewInitial: '='
        },
        restrict: 'E',
        templateUrl: 'shared/approval/templates/embedded-approval-status.tmpl.html',
        controller: 'ApprovalStatusCtrl',
        controllerAs: 'ctrl'
    }
});
